
import LoginPage from "@/components/pages/login.vue";
import "@/styles/pages/new-account.scss";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            
const components = [LoginPage];

components.forEach((component) => {
  Vue.component(component.name, component);
});

new Vue({}).$mount("#app");

          })
        